export default __webpack_public_path__ + "c099ff4145c3dca8bc4f21883984d48e.jpg";